import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AdminStore } from '../stores/admin.store';

/**
 * 관리자 인증 상태를 체크하여 비인증 사용자를 로그인 페이지로 리다이렉트하는 가드입니다.
 */
export const authGuard: CanActivateChildFn = async (
  childRoute: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const adminStore = inject(AdminStore);
  const router = inject(Router);
  const admin = adminStore.admin();

  if (admin) {
    return true;
  }

  try {
    await adminStore.fetch();
    return true;
  } catch (error) {
    return router.createUrlTree(['/sign-in']);
  }
};
